"use strict";

import Page from "./components/SubscriptionRefundPage.jsx";

export const auth = true;
export const title = "i18n:reservationRefundPage.pageTitle";
export const Component = Page;
